export const groupBy = <T>(items: T[], property: keyof T) =>
  items.reduce<Record<string, T[]>>((acc, item) => {
    const key = item[property] as any;

    if (acc[key]) {
      acc[key] = [...acc[key], item];
    } else {
      acc[key] = [item];
    }

    return acc;
  }, {});

export const sortByProp = <T>(items: T[], prop: keyof T, sign: 1 | -1 = 1): T[] =>
  items.slice().sort((itemA, itemB) => {
    const a = itemA[prop] || 0;
    const b = itemB[prop] || 0;
    const sortDirection = a < b ? -1 : a > b ? 1 : 0;
    return sortDirection * sign;
  });

export const sortByIndex = <T extends { index: number }>(items: T[], sign: 1 | -1 = 1): T[] =>
  sortByProp<T>(items, 'index', sign);
